// Bottom-right stack that consumes the `useToast` context.
//
// One mount in the Layout; every route can `useToast().push(...)`
// without thinking about positioning. Auto-dismiss happens in the
// provider; this component is a pure render.

import { useToast } from '../../lib/toast';

export function Toaster() {
  const { toasts, dismiss } = useToast();
  if (toasts.length === 0) return null;
  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex flex-col-reverse gap-2 pointer-events-none"
      aria-live="polite"
      role="status"
    >
      {toasts.map((t) => {
        const tone =
          t.intent === 'success'
            ? 'border-success-line bg-success-bg text-success'
            : t.intent === 'error'
              ? 'border-danger-line bg-danger-bg text-danger'
              : 'border-border bg-card text-foreground';
        const icon =
          t.intent === 'success' ? '✅' : t.intent === 'error' ? '❌' : 'ℹ️';
        return (
          <div
            key={t.id}
            className={`pointer-events-auto rounded-lg border shadow-sm px-4 py-3 max-w-sm ${tone}`}
          >
            <div className="flex items-start gap-3">
              <span aria-hidden className="text-base shrink-0 mt-0.5">{icon}</span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium break-words">{t.message}</p>
                {t.detail ? (
                  <p className="text-xs opacity-80 mt-0.5 break-words">{t.detail}</p>
                ) : null}
              </div>
              <button
                onClick={() => dismiss(t.id)}
                className="shrink-0 -mr-1 -mt-0.5 text-xs opacity-60 hover:opacity-100 transition-opacity p-1"
                aria-label="dismiss"
              >
                ✕
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
